<!-- ============================================================
     SEARCH ASIDE
============================================================ -->

<aside
  class="cp-search-aside"
>

  <!-- ==========================================================
       MOBILE CTA
  ========================================================== -->

  <div class="cp-mobile-cta">

    <a
      routerLink="/customer-preference"
      class="cp-mobile-cta-button"
    >

      <span class="cp-mobile-cta-icon">

        <span class="cp-mobile-cta-pulse"></span>

        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M3 10l9-7 9 7v10a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1V10z"
          />
        </svg>

      </span>

      <span>
        Get Help In Finding Property
      </span>

    </a>

  </div>


  <!-- ==========================================================
       PANEL
  ========================================================== -->

  <div class="cp-panel">

    <!-- ========================================================
         HEADER
    ======================================================== -->

    <div class="cp-panel-header">

      <div class="cp-header-left">

        <span class="cp-header-icon">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
          >
            <path
              stroke-linecap="round"
              d="M12 3v2M12 19v2M3 12h2M19 12h2"
            />

            <path
              stroke-linecap="round"
              d="M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42"
            />

            <circle
              cx="12"
              cy="12"
              r="4"
            />
          </svg>

        </span>

        <div>

          <div class="cp-header-title">
            Curated for you
          </div>

          <div class="cp-header-count">
            {{ totalProperties || 172 }} properties
          </div>

        </div>

      </div>

      <span class="cp-off-market-label">
        OFF-MARKET
      </span>

    </div>


    <div class="cp-membership-access" role="status">
      <span>{{ accessLabel }}</span>
      <a *ngIf="showUpgrade" href="/payment" class="cp-explore-plans">Explore plans <span aria-hidden="true">↗</span></a>
    </div>

    <!-- ========================================================
         TABS
    ======================================================== -->

    <div class="cp-tabs-wrapper">

      <div class="cp-tabs">

        <button
          *ngFor="let tab of getTabData"
          type="button"
          (click)="onTabChange(tab.id)"

          [ngClass]="{
            'cp-tab-active': activeTab === tab.id,
            'cp-tab-inactive': activeTab !== tab.id
          }"

          class="cp-tab"
        >

          <span>
            {{ tab.label }}
          </span>

          @if(tab.count > 0) {

            <span
              class="cp-tab-count"
              [ngClass]="{
                'cp-tab-count-active': activeTab === tab.id
              }"
            >
              {{ tab.count }}
            </span>

          }

        </button>

      </div>

    </div>


    <!-- ========================================================
         ALL LISTINGS
         KEEP #propertyContainer AND #scrollAnchor
    ======================================================== -->

    <div
      *ngIf="activeTab === 'all-listings'"
      #propertyContainer

      class="cp-property-list"
    >

      <div
        *ngFor="
          let property of filteredProperties;
          let i = index
        "
        class="cp-property-item"
      >

        <!-- SIMILAR PROPERTIES -->

        <div
          *ngIf="
            hasActiveFilters &&
            filteredCount < propertyList.length &&
            i === filteredCount
          "
          class="cp-similar-divider"
        >

          <span>✦</span>

          <i></i>

          <strong>
            Similar Properties for you
          </strong>

          <i></i>

          <span>✦</span>

        </div>

        <ng-container
          *ngTemplateOutlet="
            propertyCard;
            context: {
              $implicit: property,
              index: i
            }
          "
        ></ng-container>




      </div>


      <!-- ======================================================
           PAGINATION ANCHOR
           DO NOT REMOVE
      ====================================================== -->

      <div
        #scrollAnchor
        class="cp-scroll-anchor"
      >

        @if(isLoading) {

          <div class="cp-loading">

            <span class="cp-spinner"></span>

            <span>
              Loading more properties...
            </span>

          </div>

        }

        @if(!hasMore && propertyList.length > 0) {

          <div class="cp-end-message">

            <p>
              No more properties to show.
            </p>

            <span>

              <a routerLink="/customer-preference">
                Tell us what you are looking for
              </a>

              and we will curate properties for you.

            </span>

          </div>

        }

      </div>

    </div>


    <!-- ========================================================
         FAVORITES
    ======================================================== -->

    <div
      *ngIf="activeTab === 'favorites'"
      #propertyContainer

      class="cp-property-list"
    >

      <div
        *ngFor="
          let property of favProperties;
          let i = index
        "
        class="cp-property-item"
      >

        <ng-container
          *ngTemplateOutlet="
            propertyCard;
            context: {
              $implicit: property,
              index: i
            }
          "
        ></ng-container>

      </div>


      <div
        #scrollAnchor
        class="cp-scroll-anchor"
      >

        @if(isLoading) {

          <span class="cp-spinner"></span>

        }

      </div>

    </div>


    <!-- ========================================================
         RECENTLY VIEWED
    ======================================================== -->

    <div
      *ngIf="activeTab === 'recently-viewed'"
      #propertyContainer

      class="cp-property-list"
    >

      <div
        *ngFor="
          let property of viewPropertyDetails.data || [];
          let i = index
        "
        class="cp-property-item"
      >

        <ng-container
          *ngTemplateOutlet="
            propertyCard;
            context: {
              $implicit: property,
              index: i
            }
          "
        ></ng-container>

      </div>


      <div
        #scrollAnchor
        class="cp-scroll-anchor"
      >

        @if(isLoading) {

          <span class="cp-spinner"></span>

        }

      </div>

    </div>


  </div>


  <!-- ==========================================================
       EMPTY STATE
  ========================================================== -->

  <div
    *ngIf="
      filteredProperties.length === 0 &&
      !isLoading &&
      !hasMore
    "
    class="cp-empty-state"
  >

    <div class="cp-empty-icon">

      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      >
        <path
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16"
        />

        <path
          d="M3 21h18M9 7h1m-1 4h1m4-4h1m-1 4h1"
        />

        <path
          d="M9 21v-5a1 1 0 011-1h4a1 1 0 011 1v5"
        />
      </svg>

    </div>

    <h3>
      No Properties Found
    </h3>

    <p>
      We couldn't find any properties matching your current
      filters. Try adjusting your budget or location.
    </p>

    <a
      routerLink="/customer-preference"
      class="cp-empty-button"
    >
      Let us curate for you
    </a>

  </div>

</aside>



<!-- ================================================================
     PREMIUM PROPERTY CARD
     Updated to match the approved Circled Intelligence (CI) listing-card UI.
================================================================ -->

<ng-template
  #propertyCard
  let-property
  let-i="index"
>

  <article
    (click)="onPropertySelect(property, i)"
    [attr.data-selected]="property._id === selectedItem?._id"
    [attr.data-id]="property._id"
    class="cp-property-card mt-4"
    [ngClass]="{
      'cp-property-card-selected':
        property._id === selectedItem?._id
    }"
  >

    <!-- ==========================================================
         PROPERTY IMAGE
    ========================================================== -->

    <div class="cp-card-image">

      <img
        [src]="
          property.galleryImage &&
          property.galleryImage[0]
            ? property.galleryImage[0]
            : 'assets/img/property-placeholder.svg'
        "
        (error)="$any($event.target).getAttribute('src') !== 'assets/img/property-placeholder.svg' && ($any($event.target).src = 'assets/img/property-placeholder.svg')"
        alt="Property"
      />

      <div class="cp-image-overlay"></div>

      <!-- IMAGE BADGES -->

      <div class="cp-image-top">

        <div class="cp-image-badges">

          <span *ngIf="backendBadgeLabel(property.isExclusive, 'Exclusive') as exclusiveLabel" class="cp-image-pill cp-exclusive-pill">

            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"
              />
              <path
                d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"
              />
            </svg>

            {{ exclusiveLabel }}

          </span>

          <span *ngIf="backendBadgeLabel(property.isPropertyVerified, 'Legal Verified') as legalLabel" class="cp-image-pill" [class.cp-verified-pill]="legalLabel === 'Legal Verified'">

            {{ legalLabel }}

          </span>

          <span *ngIf="backendBadgeLabel(property.isHighDemand, 'High Demand') as demandLabel" class="cp-image-pill cp-demand-pill">{{ demandLabel }}</span>

          <span *ngIf="backendBadgeLabel(property.isInvestmentGrade, 'Investment Grade') as investmentLabel" class="cp-image-pill cp-investment-pill">{{ investmentLabel }}</span>

          <span *ngIf="backendBadgeLabel(property.type) as transactionType" class="cp-image-pill cp-sale-pill">

            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M20 13V7a2 2 0 0 0-2-2H7L3 9l4 4h11a2 2 0 0 0 2-2Z"
              />
            </svg>

            {{ transactionType }}

          </span>

        </div>

        <!-- FAVORITE -->

        <button
          type="button"
          class="cp-favorite-button"
          (click)="
            toggleFav($event, property._id);
            $event.stopPropagation()
          "
          [ngClass]="{
            'cp-favorite-active':
              _PS.isFav(property._id)
          }"
          aria-label="Add property to favorites"
        >

          <svg
            *ngIf="_PS.isFav(property._id)"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              d="M12 21.2l-1.4-1.3C5.6 15.3 2 12 2 8.3 2 5.3 4.4 3 7.4 3c1.7 0 3.4.8 4.6 2.1C13.6 3.8 15.3 3 17 3c3 0 5 2.3 5 5.3 0 3.7-3.6 7-8.6 11.6L12 21.2Z"
            />
          </svg>

          <svg
            *ngIf="!_PS.isFav(property._id)"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M20.8 8.7c0-3-2.3-5.3-5.3-5.3-1.7 0-3.4.8-4.5 2.1C9.9 4.2 8.2 3.4 6.5 3.4c-3 0-5.3 2.3-5.3 5.3 0 3.7 3.6 7 8.6 11.6L11 21.6l1.2-1.3c5-4.6 8.6-7.9 8.6-11.6Z"
            />
          </svg>

        </button>

      </div>

      <!-- IMAGE COUNT -->

      <div class="cp-image-count">

        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2"
          />
          <circle
            cx="8"
            cy="10"
            r="1.5"
          />
          <path d="m5 16 4-4 3 3 2-2 5 4" />
        </svg>

        {{ property.galleryImage?.length ? '1/' + property.galleryImage.length : 'No photos' }}

      </div>

    </div>


    <!-- ==========================================================
         CARD CONTENT
    ========================================================== -->

    <div class="cp-card-content">

      <!-- PRICE -->

      <div
        *ngIf="getPriceRange(property.price) as range"
        class="cp-card-price"
      >
        {{ range.min | inrShort }}

        <span *ngIf="!range.isSame">
          — {{ range.max | inrShort }}
        </span>
      </div>

      <div
        *ngIf="!getPriceRange(property.price)"
        class="cp-card-price"
      >
        Price not available
      </div>


      <!-- PROPERTY NAME -->

      <h3
        class="cp-card-property-name"
        [ngClass]="{
          'cp-title-selected':
            property._id === selectedItem?._id
        }"
      >
        {{ property.name | titlecase }}
      </h3>


      <!-- LOCATION -->

      <p class="cp-card-location">

        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1116 0Z"
          />
          <circle
            cx="12"
            cy="10"
            r="2.5"
          />
        </svg>

        {{ formatAddress(property) || 'Koramangala, Bengaluru' }}

      </p>


      <!-- ========================================================
           PROPERTY ATTRIBUTES
           Compact row matching the approved mobile reference.
      ======================================================== -->

      <div class="cp-property-attributes">

        <!-- BHK -->

        <span class="cp-property-attribute">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path d="M4 11h16v8H4z" />
            <path
              d="M7 11V8a3 3 0 016 0v3M16 11V9a2 2 0 014 0v2"
            />
          </svg>

          <span [class.blur-sm]="isRestricted(property)" [class.select-none]="isRestricted(property)">{{ getUniqueBhkTypes(property.price)?.[0] || 'Not available' }}</span>

        </span>


        <!-- AREA -->

        <span class="cp-property-attribute">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4"
            />
            <path
              d="M9 4 4 9M15 4l5 5M9 20l-5-5M15 20l5-5"
            />
          </svg>

          <span [class.blur-sm]="isRestricted(property)" [class.select-none]="isRestricted(property)">{{ property?.superBuiltUpArea != null ? (property.superBuiltUpArea | numberFormat) + ' Sq Ft' : 'Not available' }}</span>

        </span>


        <!-- PROPERTY TYPE -->

        <span class="cp-property-attribute">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16"
            />
            <path
              d="M3 21h18M9 7h1m-1 4h1m4-4h1m-1 4h1"
            />
          </svg>

          <span [class.blur-sm]="isRestricted(property)" [class.select-none]="isRestricted(property)">{{ property?.propertyType || 'Not available' }}</span>

        </span>

      </div>


      @if (isRestricted(property)) {
        <div class="cp-unlock-details">
          <p>View builder, size, configuration and insights</p>
          <button type="button" class="cp-unlock-details-button"
            (click)="$event.stopPropagation(); onPropertySelect(property, i)">
            <i class="fa-solid fa-lock" aria-hidden="true"></i>
            <span>Unlock full details</span>
            <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      }

      <!-- ========================================================
           CIRCLED INTELLIGENCE (CI) PREVIEW
      ======================================================== -->

      @if (ciPreview(property) | async; as ci) {
      <section
        class="cp-card-intelligence cp-card-intelligence-preview"
        (click)="$event.stopPropagation()"
      >

        <!-- CI HEADER -->

        <div class="cp-intelligence-header">

          <div class="cp-intelligence-brand">

            <span class="cp-intelligence-sparkle">
              ✦
            </span>

            <strong>
              CIRCLED INTELLIGENCE (CI)
            </strong>

          </div>

          <span class="cp-ci-preview-badge">
            Preview
          </span>

        </div>


        <!-- CI ASSESSMENT -->

        <div class="cp-ci-assessment">

          <div class="cp-ci-assessment-icon">

            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path d="M4 18h16" />
              <path d="M6 18V9" />
              <path d="M12 18V5" />
              <path d="M18 18v-6" />
            </svg>

          </div>

          <div class="cp-ci-assessment-content">

            <span class="cp-ci-label">
              CI Assessment
            </span>

            <strong class="cp-ci-verdict">

              {{ ci.verdict || ci.tags.join(' · ') || 'CI Assessment' }}

            </strong>

            <p class="cp-ci-description">

              {{ ci.summary || 'Assessment summary not available.' }}

            </p>

          </div>

        </div>


        <!-- RENTAL + NEGOTIATION -->

        <div class="cp-ci-metrics">

          <!-- RENTAL STRENGTH -->

          <div class="cp-ci-metric">

            <div class="cp-ci-metric-heading">

              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path d="M5 20V14" />
                <path d="M12 20V9" />
                <path d="M19 20V4" />
              </svg>

              <span>
                Rental Yield
              </span>

            </div>

            <span class="cp-ci-status cp-ci-status-success">

              {{ rentalYieldRating(ci) }}

            </span>

          </div>


          <!-- NEGOTIATION POTENTIAL -->

          <div class="cp-ci-metric">

            <div class="cp-ci-metric-heading">

              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path d="M7 17L17 7" />
                <circle
                  cx="7"
                  cy="7"
                  r="2"
                />
                <circle
                  cx="17"
                  cy="17"
                  r="2"
                />
              </svg>

              <span>
                Negotiation Potential
              </span>

            </div>

            <span class="cp-ci-status cp-ci-status-warning">

              {{ negotiationPotentialRating(ci, property) }}

            </span>

          </div>

        </div>


        <!-- CAPABILITIES -->

        <div class="cp-ci-capabilities">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <ellipse
              cx="12"
              cy="5"
              rx="7"
              ry="3"
            />
            <path
              d="M5 5v7c0 1.7 3.1 3 7 3s7-1.3 7-3V5"
            />
            <path
              d="M5 12v7c0 1.7 3.1 3 7 3s7-1.3 7-3v-7"
            />
          </svg>

          <span>
            {{ ciTeaser(ci) }}
          </span>

        </div>

      </section>


      <!-- ========================================================
           PRIMARY CTA
      ======================================================== -->

      <button
        type="button"
        class="cp-property-details-button"
        (click)="onPropertySelect(property, i, 'intelligence'); $event.stopPropagation()"
      >

        <span>
          Explore Circled Intelligence (CI)
        </span>

        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path d="M5 12h13" />
          <path d="m13 6 6 6-6 6" />
        </svg>

      </button>
      }
      @if (ciPreviewState(property) | async; as state) {
        @if (state.status !== 'available') {
          <p class="cp-ci-availability" role="status">{{ state.status === 'loading' ? 'Loading CI...' : state.status === 'error' ? 'Unable to load CI' : 'Circled Intelligence (CI) not available' }}</p>
        }
      }


    </div>

  </article>

</ng-template>



<!-- ================================================================
     EXPERT MODAL
================================================================ -->

<div
  *ngIf="isExpertModalOpen"
  class="cp-modal-overlay"
>

  <div class="cp-modal">

    <button
      type="button"
      (click)="closeExpertModal()"
      class="cp-modal-close"
    >
      ×
    </button>


    <div *ngIf="!isFormSubmitted">

      <h2>
        Let us know what you are looking for?
      </h2>

      <p class="cp-modal-subtitle">
        We will curate for you and contact you shortly.
      </p>


      <form
        (ngSubmit)="submitExpertForm()"
        #form="ngForm"
        class="cp-expert-form"
      >

        <input
          type="text"
          name="name"
          required
          [(ngModel)]="expertForm.name"
          placeholder="Full Name"
        />

        <input
          type="email"
          name="email"
          required
          [(ngModel)]="expertForm.email"
          placeholder="Email Address"
        />

        <input
          type="tel"
          name="mobile"
          required
          [(ngModel)]="expertForm.mobile"
          placeholder="Mobile Number"
        />

        <textarea
          rows="4"
          name="message"
          required
          [(ngModel)]="expertForm.message"
          placeholder="What are you looking for?"
        ></textarea>

        <button
          type="submit"
          [disabled]="form.invalid"
          class="cp-submit-button"
        >
          Submit Request
        </button>

      </form>

    </div>


    <div
      *ngIf="isFormSubmitted"
      class="cp-success-state"
    >

      <div class="cp-success-icon">
        ✓
      </div>

      <h3>
        Request Sent!
      </h3>

      <p>
        Our expert will contact you soon.
      </p>

      <button
        type="button"
        (click)="closeExpertModal()"
        class="cp-submit-button"
      >
        Close
      </button>

    </div>

  </div>

</div>
